module.exports = __webpack_public_path__ + "img/Referenzen_Security15.36777a19.jpg";